import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './OperationDashboard.scss';

import { dashboardURL } from '../../helpers';

class OperationDashboard extends Component {
  render() {
    const { getBuildingByRefNo } = this.props;    

    
    if (!getBuildingByRefNo) {
      return (
        <div className="OperationDashboard layout-box-page">
          <div className="box">
            <div className="title">Something went wrong.</div>
            <div className="description">please try again or feel free to contact us if the problem persists.</div>
            <div className="description">กรุณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่ดูแลระบบหากเกิดปัญหาขึ้นอีก</div>
          </div>
        </div>
      );
    }

    return (
      <div className="OperationDashboard layout-box-page">
        <iframe className="dashboard" src={getBuildingByRefNo.building.buildingInfo.buildingDashboardURL} />
      </div>
    );
  }
}

OperationDashboard.propTypes = {
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingRefNo': PropTypes.string.isRequired,
    }),
  }),
  'getBuildingByRefNo' : PropTypes.shape({
    'building' : PropTypes.shape({
      'buildingInfo' : PropTypes.shape({
        'buildingDashboardURL': PropTypes.string,
      }),
    }),
  }),
};

const mapStateToProps = ({ getBuildingByRefNo }) => ({ 'getBuildingByRefNo' : getBuildingByRefNo.data });

export default connect(mapStateToProps)(OperationDashboard);
